import React from 'react';
import { motion } from 'framer-motion';
import { Download, Mail, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-6" data-id="element-105">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-xl" data-id="element-107">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-brand-navy" data-id="element-108">
            Detén el colapso de tu hijo en menos de{' '}
            <span className="text-brand-sage" data-id="element-109">90 segundos</span>
          </h1>
          <p className="text-lg md:text-xl text-brand-navy/80 font-serif italic mb-6" data-id="element-110">
            (Sin gritos, sin amenazas y sin sentir que estás fallando como
            mamá).
          </p>
          <h2 className="text-xl md:text-2xl font-medium text-brand-navy mb-10 leading-relaxed" data-id="element-111">
            Para la madre que ha llegado a su límite y necesita recuperar la
            calma en casa sin recurrir a la disciplina del miedo.
          </h2>

          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-112">
            <Button href="#precio" className="w-full sm:w-auto flex-col gap-1 py-3" data-id="element-113">
              <span data-id="element-114">Quiero recuperar la calma</span>
              <span className="text-base font-medium opacity-90" data-id="element-115">
                $6,36 USD
              </span>
            </Button>
          </div>

          <div className="flex flex-wrap items-center gap-4 text-sm text-brand-navy/70 font-medium" data-id="element-116">
            <div className="flex items-center gap-1.5" data-id="element-117">
              <Download size={16} className="text-brand-sage" data-id="element-118" />
              <span data-id="element-119">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-120">
              <Mail size={16} className="text-brand-sage" data-id="element-121" />
              <span data-id="element-122">WhatsApp o Email</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-123">
              <ShieldCheck size={16} className="text-brand-sage" data-id="element-124" />
              <span data-id="element-125">Garantía de satisfacción</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-126">
          <div className="absolute inset-0 bg-brand-sage-light rounded-full blur-3xl opacity-60 transform scale-90" data-id="element-127"></div>
          <img src="https://cdn.magicpatterns.com/uploads/u5mGtAYH298GEYikzXKcdP/PORTADA_METODO_90_SEGUNDOS_ULTIMA.png" alt="Libro El Método de los 90 Segundos" className="relative z-10 w-full max-w-md mx-auto rounded-xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-128" />
        </motion.div>
      </div>
    </section>;
}